import useDocumentTitle from "../hooks/useDocumentTitle";

function DynamicTitle(props) {
  useDocumentTitle(props.children)
  return <div/>
}

export default DynamicTitle;